import type { Transaction } from '@tiptap/pm/state';

export function getChangedRanges(
  transactions: readonly Transaction[]
): Array<{ from: number; to: number }> {
  const ranges: Array<{ from: number; to: number }> = [];
  for (const tr of transactions) {
    tr.mapping.maps.forEach((stepMap, i) => {
      stepMap.forEach((_oldStart, _oldEnd, newStart, newEnd) => {
        const from = tr.mapping.slice(i + 1).map(newStart, -1);
        const to = tr.mapping.slice(i + 1).map(newEnd, 1);
        ranges.push({ from, to });
      });
    });
  }
  return ranges;
}
